<!--<div class="login-container">
  <div class="login-button"><button type="button" class="btn btn-secondary5 btn-lg" (click)="login()">Log In</button></div>
  <div class="login-image"><img src="assets/images/logos/logo_white.png" alt="The ISG logo in white" /></div>
  <div class="login-text">{{appname}}</div>
  <div class="login-version-text">{{buildversion}}</div>
</div>-->


<!--for IPL-->

<div *ngIf="this.workSpaceId==1 && !isAuthenticated">


  <div id="wrapper" class="wrapper">
    <header class="header" style="padding-right:45px !important; height:90px;">
      <nav class="main-navigation" style="padding: 8px 0.75% 10px 14.8%;">

        <h1 class="logo ml-1" style="margin-top: 3px; margin-left: -8.75rem !important;">
          <a href="#">

            <img class="img-responsive" src='{{workspaceDetails?.loginPageLogo}}' alt="" />
          </a>
        </h1>

        <div class="mobile-menu-holder">
          <ul>
            <li class="ipl-menuli-link"><a class="ipl-menu-link" href="https://isg-one.com/docs/default-source/2025-ipl-brochures/ipl-annual-plan-2025.pdf?sfvrsn=7663ab31_1"><!--ISG PROVIDER LENS<sup _ngcontent-c2="">TM</sup>--> 2025 AGENDA</a></li>
            <li class="ipl-menuli-link"><a class="ipl-menu-link" href="https://research.isg-one.com/"><!--ISG Provider Lens<sup _ngcontent-c2="">TM</sup>--> Subscription</a></li>
            <li class="ipl-menuli-link"><a class="ipl-menu-link" href="#" data-toggle="modal" data-target="#FAQ">FAQ</a></li>
            <li class="ipl-menuli-link"><a class="ipl-menu-link" href="#" data-toggle="modal" data-target="#contactUs">Contact Us</a></li>
            <li class="mobile-menu"><a class="" href="http://isg-one.com/who-we-are" target="_blank">Who We Are</a></li>
            <li class="mobile-menu"><a class="" href="http://isg-one.com/industries-landing" target="_blank">Industries</a></li>
            <li class="mobile-menu"><a class="" href="http://ir.isg-one.com/" target="_blank">Investors</a></li>
            <li class="mobile-menu"><a class="" href="http://isg-one.com/contact-us" target="_blank">Contact Us</a></li>
          </ul>
        </div>
        <a href="#"
           class="humburger">mobile-menu</a>
      </nav>
    </header>

  </div>

  <div class="contact-us-holder" hidden="hidden">

    <div>

      <a href="http://www.isg-one.com/contact-us" class="link-contact-us" data-toggle="modal" data-target="#contactUs">
        <span>
          contact us
          <svg viewBox="0 0 100 100" class="icon icon-contact">
            <use xlink:href="#icon-contact"></use>
            <svg id="icon-contact" viewBox="0 0 411.049 336.904"><path d="M288.543 148.136c-25.491-5.221-44.699-27.78-44.699-54.839 0-20.491 11.133-38.213 27.553-47.97 5.228 11.27 15.908 22.786 30.614 31.288 19.278 11.124 39.724 13.866 52.989 8.553.401 2.679.799 5.341.799 8.129 0 27.059-19.167 49.618-44.677 54.839 35.823-5.474 63.338-36.142 63.338-73.5C374.46 33.421 341.043 0 299.824 0c-41.201 0-74.639 33.421-74.639 74.636 0 37.358 27.552 68.026 63.358 73.5M355.07 158.457h-9.326c0 25.768-20.885 46.648-46.649 46.648-25.768 0-46.648-20.88-46.648-46.648h-9.331c-25.906 0-47.365 15.673-53.742 39.582l9.717 2.306c30.286 6.058 59.506 39.091 59.472 72.45v16.279h133.829c10.312 0 18.657-8.349 18.657-18.66v-55.977c0-30.925-25.034-55.98-55.979-55.98M107.205 250.845l3.736-15.472a9.187 9.187 0 0 1 2.606-4.483 12.838 12.838 0 0 1-1.147-.843l-33.395-27.662-20.33 4.752C24.264 215.218 0 244.294 0 277.655v43.776c0 8.618 7.671 15.473 16.836 15.473h86.058l13.128-74.791c-5.899-.07-10.208-5.5-8.817-11.268"></path><path d="M191.463 207.139l-9.718-2.306-10.306-2.447-33.387 27.661a23.32 23.32 0 0 1-1.085.844 9.181 9.181 0 0 1 2.605 4.483l3.736 15.473c1.39 5.768-2.919 11.197-8.826 11.302l13.135 74.79h86.032c9.191 0 16.151-6.889 16.151-15.507V277.656c.035-33.361-23.89-62.438-58.337-70.517M150.798 80.951c15.121 10.53 25.374 39.878 25.374 61.99 0 29.201-17.688 53.544-41.163 59.179 19.228-3.446 35.859-16.144 46.393-34.12 7.316 2.818 15.874-3.671 19.228-14.666 3.395-11.132.169-22.66-7.205-25.75l-.013-.005c1.438-11.049 1.84-23.789.393-34.001-3.731-26.347-16.927-45.727-29.475-43.286-.616.119-1.219.262-1.806.429-10.868-9.656-23.897-15.54-37.904-15.54-53.358 0-68.73 43.145-68.73 87.621 0 1.929.077 3.836.191 5.73-6.11 4.065-8.563 14.597-5.451 24.801 3.093 10.138 10.609 16.447 17.497 15.162 10.54 17.71 27.033 30.209 46.091 33.623-23.492-5.635-41.143-29.979-41.143-59.179 0-3.007.367-17.68.738-20.57 12.214 5.733 31.044 2.775 48.795-9.229 13.542-9.174 23.377-20.029 28.19-32.189"></path></svg>
          </svg>
        </span>
      </a>

    </div> <div class="contact-form"> </div>
  </div>
  <div class="form-control-feedback alert-heading p-2" style="color: #ff0000" data-toggle="modal" *ngIf="message!==''">
    <i class="fa fa-info-circle fa-lg mt-1" style="color: #ff0000"></i>
    <b>{{message}}</b>
  </div>
  <body class="ipl-banner">

    <main class="main col-md-offset-1 col-lg-offset-2 col-sm-offset-1 col-xs-offset-1 home-ipl" style="background-size: 100% 100% !important; background-position-y: 0 !important; display: flex; align-items: center; ">

      <div class="isg-tabular">
      </div>
      <a href="#" class="scroll-down col-md-offset-2 col-sm-offset-2 col-xs-offset-2" style="top: -14%; ">
      </a>

      <form [formGroup]="loginForm" #f="ngForm" (ngSubmit)="login()">
        <div class="form-container row col-lg-5 col-md-5 col-sm-6 col-xs-12" style="background-color: rgba(19,59,118,0.5); margin-left: 195px; padding: 60px 40px; ">
          <!--<br>-->
          <!--<h4 style="text-align:center;text-transform: uppercase;margin: 0;color: #fff;font-family: Open Sans,Roboto Slab,Helvetica Neue, Arial, sans-serif;">Login To IPL Portal</h4>-->
          <!--<hr style="width: 113px;margin-top: 27px;margin-left:-121px" />-->
          <div class="form-control-feedback alert-heading p-2" style="color: #ff0000" data-toggle="modal" *ngIf="validinvalidmessage!==''">
            <i class="fa fa-info-circle fa-lg mt-1" style="color: #ff0000"></i>
            <b>{{validinvalidmessage}}</b>
          </div>
          <div class="form-group row col-md-12 col-md-offset-0" style="display:none;">

            <input type="text" (keydown)="onKeydown($event)" id="userName" name="userName" formControlName="userName" class="form-control" style="border:0" placeholder="Enter UserName" #userName />
          </div>
          <div class="form-group row col-md-12 col-md-offset-0" style="display:none;">

            <input type="password" (keydown)="onKeydown($event)" id="password" name="password" formControlName="password" class="form-control" style="border:0" placeholder="Enter Password" #password />
          </div>
          <div style="color: white; padding-bottom: 10px; font-family: Open Sans,Roboto Slab,Helvetica Neue, Arial, sans-serif;">
            ISG Provider Lens™ is a practitioner-led service provider comparison, empowered by ISG’s advisory experience and data-driven research. Research reports provide independent vendor evaluations and enterprise buying behavior segmentation.
            Please refer to the IPL Agenda at the top of the page. If you would like to participate in specific studies or require assistance with your login credentials, please utilize the <a href="#" data-toggle="modal" data-target="#contactUs" style="color:white;">contact us</a> form to provide us with the list of studies you are interested in.
          </div>
          <div class="row col-md-12 col-md-offset-0">
            <!--<button type="button" (click)="login()" class="btn btn-sm btn-success col-md-4" name="SignIn" id="SignIn" style="width:100px;background-color:#9acb3b;border: 1px solid #fff;color:#000;font-size:14px">Sign In</button>-->
            <button class="btn btn-sm btn-success col-md-4" (click)="login()" style="background-color: #ff8a26; border: 1px solid #fff; color: #fff; font-size: 14px; margin: 12px auto 0 auto; font-family: Open Sans,Roboto Slab,Helvetica Neue, Arial, sans-serif;">Login</button>
            <!--<input type="button" value="Activate My Account" class="btn btn-sm btn-success col-md-7" data-toggle="modal" data-target="#forgotAccontModel" style="background-color:#9acb3b;border: 1px solid #fff;color:#000;font-size:12px" />-->

          </div>

          <div class="clearfix"></div>
        </div>

      </form>
    </main>
   
    <footer class="footer isg-plain-footer2 ">
      <a href="https://isg-one.com/isg-provider-lens-portal-terms-of-use" style="margin-right: 25px; font-size: 0.87rem; color: #fff;">Terms of Use</a>
      © {{currentYearLong()}} Information Services Group. All Rights Reserved.
    </footer>
  </body>



</div>


<!--for Assesment-->
<!--new Layout-->

<div style="width:100%" *ngIf="this.workSpaceId==2 && !isAuthenticated">
  <!--<link href="https://iwb.isg-one.com/Content/css?v=aqQ5pVM4mFsJ4JW_XbeFtm8fgSZ1Z96Q7tepZi7P8a01" rel="stylesheet" />-->
  <div id="wrapper" class="wrapper assesment">
    <header class="header">
      <nav class="main-navigation">
        <h1 class="logo">
          <a href="/">
            <img class="img-responsive LoginPageImage" src='../../../../../assets/images/assesment-logo.svg' alt="" style="width: 380px;" />
          </a>
        </h1>
        <div class="mobile-menu-holder">

        </div>
        <a href="#"
           class="humburger"></a>
      </nav>


    </header>
    <main class="main" style="background-image: url();">
      <div class="login-container">
        <div class="login-button-container">
          <section id="loginForm">

            <form [formGroup]="loginForm" #f="ngForm" (ngSubmit)="login()" class="form-horizontal">
              <div class="form-group row col-md-12 col-md-offset-0 mt-5 ml-1" style="display:none">
                <label class="form-control-label font-weight-bold font-sm" style="color:white;">Username</label>
                <input type="text" (keydown)="onKeydown($event)" id="userName" name="userName" formControlName="userName" class="form-control" placeholder="Enter UserName" #userName />
              </div>
              <div class="form-group row col-md-12 col-md-offset-0 mt-1 ml-1" style="display:none">

                <label class="form-control-label font-weight-bold font-sm" style="color:white;">Password</label>
                <input type="password" autocomplete="off" (keydown)="onKeydown($event)" id="password" name="password" formControlName="password" class="form-control" placeholder="Enter Password" #password />
              </div>
              <div class="row col-md-12 col-md-offset-0 mt-3 ml-5" style="padding-left: 12%">
                <input type="submit" (click)="login()" class="btn btn-default" name="SignIn" id="SignIn" value="Log in" />
              </div>
              <div class="row col-md-12 col-md-offset-0">
                <label>

                </label>
              </div>
            </form>

          </section>
        </div>
        <div class="login-image">
        </div>
        <div class="login-text">
          <img src="../../../../../assets/images/text.svg" />

        </div>
      </div>
    </main>


    <footer class="footer isg-plain-footer " style="color:white; ">
      <div>
        <a href="https://isg-one.com/assessments-terms-of-use" style="margin-right: 25px; text-decoration: none; font-size: 0.87rem; color: #fff;">Terms of Use</a>© {{currentYearLong()}} Information Services Group. All Rights Reserved.
      </div>
    </footer>
  </div>
</div>


<div class="modal fade" id="resources" tabindex="-1" role="dialog" aria-labelledby="resources" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>Team</b></h4>
        <p style="color:black">Resources content</p>

      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="contactUsHome" tabindex="-1" role="dialog" aria-labelledby="contactUsHome" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>Contact Us</b></h4>
        <p style="color:black">If you have any questions around the broader ISG Quadrant Research program or the Software Defined Networking and Services Survey, kindly email at <a class="text-primary" style="color:black" href={{this.workspaceDetails?.hostName}}><u>{{this.workspaceDetails?.supportEmail}}</u></a></p>

      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="contactUsHome" tabindex="-1" role="dialog" aria-labelledby="contactUsHome" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>Contact Us</b></h4>
        <p style="color:black">If you have any questions around the broader ISG Quadrant Research program or the Software Defined Networking and Services Survey, kindly email at <a class="text-primary" style="color:black" href={{this.workspaceDetails?.hostName}}><u>{{this.workspaceDetails?.supportEmail}}</u></a></p>

      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="aboutUs" tabindex="-1" role="dialog" aria-labelledby="aboutUs" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>About Us</b></h4>
        <p style="color:black">About Us content</p>

      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="R360Lite" tabindex="-1" role="dialog" aria-labelledby="R360Lite" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>R360Lite</b></h4>
        <p style="color:black">R360Lite content</p>

      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="UserX" tabindex="-1" role="dialog" aria-labelledby="UserX" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>UserX</b></h4>
        <p style="color:black">UserX content</p>

      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="Voiceofcustomer" tabindex="-1" role="dialog" aria-labelledby="Voiceofcustomer" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>Voice of Customer</b></h4>
        <p style="color:black">Voice of Customer content</p>

      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="team" tabindex="-1" role="dialog" aria-labelledby="team" aria-hidden="true">
  <div class="modal-dialog model-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>Team</b></h4>
        <p style="color:black">Team content</p>

      </div>

    </div>
  </div>
</div>
<!--</div>-->

<div class="modal fade" id="forgotAccontModel" tabindex="-1" role="dialog" aria-labelledby="forgotAccontModel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Activate Your Account</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">

        <form [formGroup]="forgotAccountForm" #f="ngForm">

          <div class="form-group">
            <label class="form-control-label-small">Type in your email address associated with your login at the IPL Portal below and an email will be sent to you to create your password.</label>
            <label class="form-control-label-small" for="eamil">Enter Email </label>
            <input type="text" id="eamil" name="email" (keydown)="onKeydownForgot($event)" formControlName="email" class="form-control" placeholder="Enter Email" #email style="border:1px solid black" />
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary" data-dismiss="modal" (click)="forgotPassword()">SUBMIT</button>
          </div>
        </form>
      </div>

    </div>
  </div>
</div>



<div class="modal fade" id="contactUs" tabindex="-1" role="dialog" aria-labelledby="contactUs" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel" style="font-size: 15px; margin: 0.20em 0 ">Contact Us</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form [formGroup]="contactusForm" #f="ngForm">

        <div class="form-group" style="padding:40px !important">
          <label data-required class="form-control-label" for="companyname">Company Name </label>
          <input type="text" id="companyname" name="companyname" formControlName="companyname" class="form-control border-bottom " placeholder="" required />

          <label data-required class="form-control-label" for="firstname">First Name </label>
          <input type="text" id="firstname" name="firstname" formControlName="firstname" class="form-control border-bottom" placeholder="" />

          <label for="lastname" class="form-control-label">Last Name </label>
          <input type="text" id="lastname" name="lastname" formControlName="lastname" class="form-control border-bottom" placeholder="" />

          <label data-required for="email" class="form-control-label">Email </label>
          <input type="text" id="email" name="email" formControlName="email" class="form-control border-bottom" placeholder="" />
          <label for="comments" class="form-control-label">How can we help? </label>
          <textarea class="form-control rounded-0" id="comments" name="comments" rows="3" formControlName="comments"></textarea>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" style="margin-right: 39%;" (click)="contactsumbit()" [disabled]="!contactusForm.valid" data-dismiss="modal">SUBMIT</button>
        </div>
      </form>



    </div>

  </div>
</div>

<div class="modal fade" id="FAQ" tabindex="-1" role="dialog" aria-labelledby="FAQ" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" style="background-color:white">

      <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" style="color:black">&times;</button>
        <h4 style="color:black;text-align:center"><b>FAQ</b></h4>


        <div *ngFor="let question of this.FAQList let i =index">

          <label class="form-control-label-small col-md-12 row font-weight-bold">
            {{i+1}}. {{question.questionText}}
          </label>

          <label class="form-control-label-small mx-3" [innerHTML]="question.answer"> </label>
          <div class="pt-1">
            <img class="img-fluid" src='{{question?.imageBlob }}' />
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
<div class="modal fade" id="helpModel" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="helpModel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content" style="background-color:white">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" (click)="stopPlayer()">&times;</button>
        <h4 class="modal-title"></h4>
      </div>
      <div class="modal-body">

        <div class="player-wrapper">
          <video id='plyrID' controls crossorigin playsinline poster="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-HD.jpg">
            <source src="https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4" type="video/mp4" size="576">
          </video>
        </div>

      </div>

    </div>
  </div>
</div>

<div class="modal fade" id="contactUs" tabindex="-1" role="dialog" aria-labelledby="contactUs" aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Contact Us</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form [formGroup]="contactusForm" #f="ngForm">

        <div class="form-group" style="padding:40px !important">
          <label data-required class="form-control-label" for="companyname">Company Name </label>
          <input type="text" id="companyname" name="companyname" formControlName="companyname" class="form-control border-bottom " placeholder="" required />

          <label data-required class="form-control-label" for="firstname">First Name </label>
          <input type="text" id="firstname" name="firstname" formControlName="firstname" class="form-control border-bottom" placeholder="" />

          <label for="lastname" class="form-control-label">Last Name </label>
          <input type="text" id="lastname" name="lastname" formControlName="lastname" class="form-control border-bottom" placeholder="" />

          <label data-required for="email" class="form-control-label">Email </label>
          <input type="text" id="email" name="email" formControlName="email" class="form-control border-bottom" placeholder="" />
          <label for="comments" class="form-control-label">How can we help? </label>
          <textarea class="form-control rounded-0" id="comments" name="comments" rows="3" formControlName="comments"></textarea>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary" style="margin-right: 39%;" (click)="contactsumbit()" [disabled]="!contactusForm.valid" data-dismiss="modal">SUBMIT</button>
        </div>
      </form>

    </div>
  </div>
</div>





<style>
  .home-ipl {
    height: calc(100vh - 136px) !important;
    background-position: right bottom;
    background-size: 100%;
  }

  .isg-plain-footer2 {
    color: white;
    text-align: center;
    padding: 15px 13.75% 15px !important;
    font-family: 'Open Sans', 'Roboto Slab', "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }

  .header .main-navigation li a.ipl-menu-link {
    color: #000 !important;
    font-size: 0.9rem !important;
    padding-top: 27px !important;
    font-family: 'Open Sans', 'Roboto Slab', "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }

  .header .main-navigation li.ipl-menuli-link {
    padding-top: 27px !important;
  }
</style>

